<template>
  <div class="profileStats">
    <section class="profile__block">
      <div class="profile__block__header">
        <h2>{{ getTranslations.home_profile_profile_stats_your_status }}</h2>
      </div>
      <div class="profile__block__content profile__block__content--stats">
        <ul class="profile__block__content__stats">
          <li>
            {{ numberFormatting(userDetails.level) }} <span>{{ getTranslations.home_profile_profile_level }}</span>
          </li>
          <li>
            {{ numberFormatting(userDetails.totalPointsEarned) }} <span>{{ getTranslations.home_profile_profile_points }}</span>
          </li>
          <li>
            {{ numberFormatting(userDetails.gamesPlayed) }} <span>{{ getTranslations.home_profile_profile_games }}</span>
          </li>
        </ul>
      </div>
    </section>
    <facebook-login v-if="hasFb()"
                    :enteredUsername="userDetails.username"
                    :previousComponentFacebook="profilePage">
    </facebook-login>
  </div>
</template>

<script>
import FacebookLogin from '@/components/visitor/FacebookLogin';
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  components: {
    FacebookLogin,
  },
  data() {
    return {
      profilePage: 'profile',
    };
  },
  methods: {
    hasFb() {
      return this.$route.path === '/home/profile' && !this.userDetails.facebookId && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue